<template>
    <v-card>
        <v-card-title>
            {{  $t('aws_settings')  }} -- {{ webinar.title}}
        </v-card-title>
        <v-card-text>
            <v-form ref="awsSettingsForm">
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="awsSettingsEditedItem.endpoint_url" label="endpoint url" class="left-input mt-3" ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="awsSettingsEditedItem.region" label="region" class="left-input mt-3">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="awsSettingsEditedItem.access_key" label="access key"  class="left-input mt-3"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="awsSettingsEditedItem.secret_key" label="secret key"  class="left-input mt-3"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="awsSettingsEditedItem.bucket" label="bucket"  class="left-input mt-3"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="awsSettingsEditedItem.static_site_url" label="static site url"  class="left-input mt-3"></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn text color="green darken-2" @click="saveAwsSettings">
                {{  $t('save')  }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="red darken-2" @click="removeAskDialog=true">
                {{  $t('remove')  }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="close">
                {{  $t('close')  }}
            </v-btn>
        </v-card-actions>
        <v-dialog v-model="removeAskDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <v-icon large right color="red"> mdi-comment-question-outline</v-icon>
                </v-card-title>
                <v-card-text>
                    {{ $t('webinar_aws_settings_remove_ask')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="removeAwsSettings">{{ $t('yes') }}</v-btn>
                    <v-btn color="primary" text @click="removeAskDialog=false">{{ $t('no') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import axios from 'axios'
export default {
    name: 'AwsSettings',
    props: ['webinar'],
    data() {
        return {
            awsSettingsEditedItem: { endpoint_url: "", region: "", access_key: "" ,secret_key:"", bucket:"", static_site_url:""},
            awsSettingsDefaultItem: { endpoint_url: "", region: "", access_key: "" ,secret_key:"", bucket:"", static_site_url:"" },
            saveLoading: false,
            deleteLoading: false,
            removeAskDialog:false,
        }
    },
    watch:{
        webinar:{
            handler(){
                this.getAwsSettings();
            },
            deep:true
        }
    },
    methods: {

        getAwsSettings() {
            axios({
                url: `${process.env.VUE_APP_BACKEND_URL}/api/webinar_plus/companies/${this.webinar.id}/aws_settings`,
                method: "GET",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
            }).then(response => {
                this.awsSettingsEditedItem = Object.assign({}, response.data.data);
               // this.awsSettingsEditedItem.bigbluebutton_record=(response?.data?.data?.bigbluebutton_record==1?true:false)
            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("no_aws_settings"));
            });
        },
        saveAwsSettings() {
            console.log(this.awsSettingsEditedItem)
            let payload={...this.awsSettingsEditedItem};
            axios({
                url: `${process.env.VUE_APP_BACKEND_URL}/api/webinar_plus/companies/${this.webinar.id}/aws_settings`,
                method: "POST",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
                data: payload,
            }).then(() => {
                this.$toasted.success(this.$t("aws_settings_save_successfully"));
                this.close()

            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("aws_settings_saving_error"));
            });
        }, 
        removeAwsSettings() {
            axios({
                url: `${process.env.VUE_APP_BACKEND_URL}/api/webinar_plus/companies/${this.webinar.id}/aws_settings`,
                method: "DELETE",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
            }).then(() => {
                this.awsSettingsEditedItem = Object.assign({}, this.awsSettingsDefaultItem);
                this.$toasted.success(this.$t("aws_settings_delete_successfully"));
                this.removeAskDialog=false;
                this.close();

            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("aws_settings_deleteing_error"));
            });
        },
   
        close() {
            // this.awsSettingsEditedItem = Object.assign({}, this.awsSettingsDefaultItem);
            //this.selectedAwsSettings={bigbluebutton_secret:'',bigbluebutton_url:''}
            this.$emit('close');
        }
    },
    mounted() {
        this.getAwsSettings();
    },



}
</script>
<style >
.left-input input{
    text-align: left;
    direction: ltr;
}
</style>